import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'state/store';
import styled from 'styled-components';

const TimerWrapper = styled('div')`
  display: flex;
`;

interface DistributionTimerProps {
  startAt: number;
}

const DistributionTimer = ({ startAt }: DistributionTimerProps) => {
  const startAtSeconds = Math.floor((Date.now() - startAt) / 1000);
  const [timeInSeconds, setTimeInSeconds] = useState(startAtSeconds);
  const isMarkedDone = useSelector((state: RootState) => state.lead.isMarkedDone);
  const [intervalId, setIntervalId] = useState<number | null>();
  // Time calculator
  let days: number = Math.max(Math.floor(timeInSeconds / (3600 * 24)), 0);
  let hours: number = Math.max(Math.floor((timeInSeconds % (3600 * 24)) / 3600), 0);
  let minutes: number = Math.max(Math.floor((timeInSeconds / 60) % 60), 0);
  let seconds: number = Math.max(Math.floor(timeInSeconds % 60), 0);

  useEffect(() => {
    const intHandle = window.setInterval(() => {
      setTimeInSeconds((prevTimeInSeconds) => prevTimeInSeconds + 1);
    }, 1000);
    setIntervalId(intHandle);
    return () => {
      clearInterval(intHandle);
    };
  }, []);

  useEffect(() => {
    if (isMarkedDone && intervalId) {
      clearInterval(intervalId);
    }
  }, [intervalId, isMarkedDone]);

  return (
    <TimerWrapper>
      {/* Dont show days timer if its not up to a day */}
      {/* If any unit of time is single digit, render a preceding '0' for uniformity */}
      {days !== 0 && <p>{days < 10 ? `0${days}` : days}&nbsp;:&nbsp;</p>}
      <p>{hours < 10 ? `0${hours}` : hours}&nbsp;:&nbsp;</p>
      <p>{minutes < 10 ? `0${minutes}` : minutes}&nbsp;:&nbsp;</p>
      <p>{seconds < 10 ? `0${seconds}` : seconds}</p>
    </TimerWrapper>
  );
};

export default DistributionTimer;
